import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/regenerator";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { ArgumentNullError, createNoDashGuid } from "../common/Exports";
import { WebsocketMessageAdapter } from "./WebsocketMessageAdapter";
export var WebsocketConnection = /*#__PURE__*/function () {
  function WebsocketConnection(uri, queryParameters, headers, messageFormatter, proxyInfo) {
    var _this = this;

    var enableCompression = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var connectionId = arguments.length > 6 ? arguments[6] : undefined;

    _classCallCheck(this, WebsocketConnection);

    this.privIsDisposed = false;

    this.isDisposed = function () {
      return _this.privIsDisposed;
    };

    this.state = function () {
      return _this.privConnectionMessageAdapter.state;
    };

    this.open = function () {
      return _this.privConnectionMessageAdapter.open();
    };

    this.send = function (message) {
      return _this.privConnectionMessageAdapter.send(message);
    };

    this.read = function () {
      return _this.privConnectionMessageAdapter.read();
    };

    if (!uri) {
      throw new ArgumentNullError("uri");
    }

    if (!messageFormatter) {
      throw new ArgumentNullError("messageFormatter");
    }

    this.privMessageFormatter = messageFormatter;
    var queryParams = "";
    var i = 0;

    if (queryParameters) {
      for (var paramName in queryParameters) {
        if (paramName) {
          queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
          var val = encodeURIComponent(queryParameters[paramName]);
          queryParams += "".concat(paramName, "=").concat(val);
          i++;
        }
      }
    }

    if (headers) {
      for (var headerName in headers) {
        if (headerName) {
          queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";

          var _val = encodeURIComponent(headers[headerName]);

          queryParams += "".concat(headerName, "=").concat(_val);
          i++;
        }
      }
    }

    this.privUri = uri + queryParams;
    this.privId = connectionId ? connectionId : createNoDashGuid();
    this.privConnectionMessageAdapter = new WebsocketMessageAdapter(this.privUri, this.id, this.privMessageFormatter, proxyInfo, headers, enableCompression);
  }

  _createClass(WebsocketConnection, [{
    key: "dispose",
    value: function dispose() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.privIsDisposed = true;

                if (!this.privConnectionMessageAdapter) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this.privConnectionMessageAdapter.close();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "id",
    get: function get() {
      return this.privId;
    }
  }, {
    key: "events",
    get: function get() {
      return this.privConnectionMessageAdapter.events;
    }
  }]);

  return WebsocketConnection;
}();